const priorities: PriorityArray = [
  { id: "1", level_of_priority: 0, title: "None" },
  { id: "2", level_of_priority: 1, title: "Low" },
  { id: "3", level_of_priority: 2, title: "Medium" },
  { id: "4", level_of_priority: 3, title: "High" },
];

export { priorities as default };
